import React, { useContext, useEffect, useState } from "react";
import "../../assets/styles/load-skirts.scss";
import { Button, Card, Col, Form, Modal, Row } from "react-bootstrap";
import SmuBadge from "../../utils/smu-badge/SmuBadge";
import SmuFileUploader from "../../utils/smu-file-uploader/SmuFileUploader";
import { Tree } from "@minoru/react-dnd-treeview";
import SkirtItem from "./parts/SkirtItem";
import _ from "lodash";
import { COLOR_PRIMARY } from "../../constants/colors";
import { StoreContext } from "../../store/StoreContext";
import { fetchFaldonesByCategoryAndTienda, deleteFile, uploadFileByCategory, uploadFaldonXlsx, deleteFaldonXlsx } from "../../api/files";
import { toast } from "../../helpers/smu-alerts/smu-lerts";
import Select from "react-select";
import { prepareText, resolveUserTienda } from "../../helpers";
import errorIcon from "../../assets/images/error.png";
import successIcon from "../../assets/images/success.png";
import SmuLoading from "../../utils/smu-loading/SmuLoading";
import SmuButton from "../../utils/smu-button/SmuButton";
import { IconBasket } from "../../icons/Icon";
import SmuTable from "../../utils/smu-table/SmuTable";
import Swal from "sweetalert2";
import { parseFaldonXlsx } from "../../utils/xlsx/parseFaldon";
import PreviewXlsxModal from "./PreviewXlsxModal";
import { SMU_SELECTED_MENU } from "../../constants";

const acceptedXlsxTypes = ["XLSX"];
const brand = process.env.REACT_APP_BRAND || "S10";

const LoadSkirts = () => {
  const { skirts, promotions, loggedUser, isAdmin, loadingSkirt } = useContext(StoreContext);

  const [treeData, setTreeData] = useState([]);
  const [selectedSkirt, setSelectedSkirt] = useState(null);
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [filesToUpload, setFilesToUpload] = useState([]);
  const [multiFiles, setMultiFile] = useState([]);
  const [files, setFiles] = useState([]);
  const [promoErr, setPromoErr] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [summaryModal, setSummaryModal] = useState(false);
  const [summaryUpload, setSummaryUpload] = useState([]);
  const [loading, setLoading] = useState(false);
  const [xlsxToUpload, setXlsxToUpload] = useState([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [parsedFilesPreview, setParsedFilesPreview] = useState([]);

  const promotion = promotions.find(
    (p) => selectedOption?.value === p.ID_PROMO
  );
  const options = promotions.map((promo) => ({
    label: promo.DESCRIPCION_PROMO,
    value: promo.ID_PROMO,
  }));
  const hnadleFetchFiles = (skirtId) => {
    setLoading(true);
    fetchFaldonesByCategoryAndTienda(skirtId, resolveUserTienda(isAdmin, loggedUser), loggedUser?.username)
      .then(({ data, error }) => {
        if (!!error) throw new Error(error?.message);
        const faldones = (data || []).map(faldon => ({
          ...faldon,
          filename: faldon.FALDON_XLSX.replace(/\.(xlsx|xls)$/i, ''),
          id: faldon.FALDON_XLSX,
          views: faldon.VIEWS,
        }));
        setFiles(faldones);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        toast({ icon: "error", title: "Error al traer faldones. Reintente otra vez" });
      });
  };

  const makePath = (_skirt) => {
    let result = [];

    skirts.forEach((s, i) => {
      if (s.id === _skirt.parent) {
        let _skirts = makePath(s);
        result = [...result, s, ..._skirts];
      }
      result = [...result, _skirt];
    });

    return _.uniqBy(result, "id");
  };

  useEffect(() => {
    const _skirts = skirts.map((skirt) => ({
      ...skirt,
      droppable: false,
      parent: skirt?.parent || 0,
    }));
    setTreeData(_skirts);
    
    // Load selected menu from localStorage on mount
    const savedSelectedMenu = localStorage.getItem(SMU_SELECTED_MENU);
    if (savedSelectedMenu && _skirts.length > 0) {
      try {
        const savedMenu = JSON.parse(savedSelectedMenu);
        const foundSkirt = _skirts.find((s) => s.id === savedMenu.id);
        if (foundSkirt) {
          setSelectedSkirt(foundSkirt);
          const __skirts = makePath(foundSkirt);
          const _breadcrumbs = __skirts.map((_skirt) =>
            _skirt.title.replace("/", "")
          );
          setBreadcrumbs(_breadcrumbs.reverse());
        }
      } catch (err) {
        console.error("Error loading selected menu:", err);
      }
    }
  }, [skirts]);

  // Cleanup: clear selection when component unmounts (user exits this view)
  useEffect(() => {
    return () => {
      // Clear selected menu when leaving this view
      setSelectedSkirt(null);
      setBreadcrumbs([]);
      localStorage.removeItem(SMU_SELECTED_MENU);
    };
  }, []);

  // useEffect(() => {
  //   if (!selectedSkirt?.id) return;
  //   hnadleFetchFiles(selectedSkirt.id);
  // }, [selectedSkirt?.id]);

  // useEffect(() => {
  //   if (summaryModal) return;
  //   setSummaryUpload([]);
  // }, [summaryModal]);

  const handleChoseSkirt = (_skirt) => {
    if (selectedSkirt?.id === _skirt.id) {
      // Deselect if clicking the same item
      setSelectedSkirt(null);
      setBreadcrumbs([]);
      // Remove from localStorage when deselected
      localStorage.removeItem(SMU_SELECTED_MENU);
      return;
    }

    // Select new item
    setSelectedSkirt(_skirt);
    const __skirts = makePath(_skirt);
    const _breadcrumbs = __skirts.map((_skirt) =>
      _skirt.title.replace("/", "")
    );
    setBreadcrumbs(_breadcrumbs.reverse());
    
    // Save selected menu to localStorage
    localStorage.setItem(SMU_SELECTED_MENU, JSON.stringify(_skirt));
  };

  // !!! DEPRECATED old file upload with no restrictions !!!
  const handleUploadFile = async () => {
    if (!promotion?.ID_PROMO) {
      setPromoErr(true);
      return { error: true };
    }
    setPromoErr(false);

    const file = filesToUpload[0];
    if (!file)
      return toast({
        icon: "error",
        title: "No fue posible cargar el archivo.",
      });

    const metadata = { fileName: file.name };
    const formData = new FormData();
    formData.append("document", file, file.name);
    formData.append("category", selectedSkirt?.id);
    formData.append("metadata", JSON.stringify(metadata));
    formData.append("promotion_id", promotion.ID_PROMO);
    formData.append("filetype", "Faldon");

    const result = await uploadFileByCategory(formData);
    if (!selectedSkirt?.id) return;
    hnadleFetchFiles(selectedSkirt.id);
    return result;
  };

  const calculateCategoryMenu = (fileName) => {
    const name = fileName;
    const nameSplit = fileName.split("-");
    const lastIndex = nameSplit.length - 1;

    let brandName = null;
    let _skirts = [];
    nameSplit.forEach((segment, index) => {
      const validation =
        index < lastIndex &&
        segment.length === 3 &&
        !segment.includes(" ") &&
        !segment.includes(".");
      if (index === 0) brandName = segment;
      else if (validation) _skirts.push(segment);
    });
    const _skirt = skirts.find(s => _skirts.join("-") === s.code);
    
    // Get category_menu from localStorage if available
    const savedSelectedMenu = localStorage.getItem(SMU_SELECTED_MENU);
    let categoryMenu = null;
    if (savedSelectedMenu) {
      try {
        const parsedMenu = JSON.parse(savedSelectedMenu);
        categoryMenu = parsedMenu?.id || null;
      } catch (err) {
        console.error("Error parsing SMU_SELECTED_MENU:", err);
        return null;
      }
    } else {
      // If no menu is selected, try to get it from the file name using the _skirt code found
      if(!_skirt) return null;
      categoryMenu = treeData.find(s => s.code === _skirt.code)?.id || null;
      if (!categoryMenu) {
        return null;
      }
    }

    //return;
    // Only reject MENU-NOT-FOUND if categoryMenu is not valid (null/empty)
    // If categoryMenu is valid, bypass this validation and use the selected menu
    if ((lastIndex <= 1 || !_skirt) && (!categoryMenu || categoryMenu === ""))
      return null;

    return categoryMenu;
  }

  const handleUploadFileMultiple = (faldon_version_json_dict) => {
    if (!loggedUser?.username) {
      toast({ icon: "error", title: "No se encontró la sesión del usuario." });
      return {error: true, type: 'faldon'};
    }
    setLoading(true);
    return new Promise((resolve, reject) => {
      Promise.allSettled(
        multiFiles.map((file) => {
          const name = file.name;
          const nameSplit = file.name.split("-");
          const lastIndex = nameSplit.length - 1;

          
          let brandName = null;
          let _skirts = [];
          nameSplit.forEach((segment, index) => {
            const validation =
              index < lastIndex &&
              segment.length === 3 &&
              !segment.includes(" ") &&
              !segment.includes(".");
            if (index === 0) brandName = segment;
            else if (validation) _skirts.push(segment);
          });


          // const _promo = promotions.find((p) => {
          //   const description = prepareText(p.DESCRIPCION_PROMO);
          //   const _promotionName = prepareText(file.name);
          //   return _promotionName.includes(description);
          // });

          // descomentar, printear si envía bien el mapeo de carpetas, sin enviar, carga forzada
          // ver caso en que se selecciona una carpeta y el usuario se arrepiente, limpiar variable?
          const _skirt = skirts.find(s => _skirts.join("-") === s.code );
          
          // Print what would be sent before validation checks
          const faldonVersionJson = faldon_version_json_dict[name];
          // Get category_menu from localStorage if available
          const savedSelectedMenu = localStorage.getItem(SMU_SELECTED_MENU);
          let categoryMenu = null;
          if (savedSelectedMenu) {
            try {
              const parsedMenu = JSON.parse(savedSelectedMenu);
              categoryMenu = parsedMenu?.id || null;
            } catch (err) {
              console.error("Error parsing SMU_SELECTED_MENU:", err);
            }
          } else {
            // If no menu is selected, try to get it from the file name using the _skirt code found
            if(!_skirt) return Promise.reject("MENU-NOT-FOUND");
            categoryMenu = treeData.find(s => s.code === _skirt.code)?.id || null;
            if (!categoryMenu) {
              return Promise.reject("MENU-NOT-FOUND");
            }
          }
                    
          //return;
          // Only reject MENU-NOT-FOUND if categoryMenu is not valid (null/empty)
          // If categoryMenu is valid, bypass this validation and use the selected menu
          if ((lastIndex <= 1 || !_skirt) && (!categoryMenu || categoryMenu === ""))
            return Promise.reject("MENU-NOT-FOUND");
          // enviar a files.jsx -> uploadFaldonXlsx agregar obligatoriamente category_menu
          // en previewXLSXModal, cambiar active step al 2

          if (brandName !== brand) 
            return Promise.reject("NO-BRAND");
          // Deprecated - now validation is in backend
          //else if (!_promo) 
          //  return Promise.reject("NOT-FOUND-PROMOTION");
          
          // Return resolved promise to simulate successful upload (without actually sending)
          // return Promise.resolve({
            // data: {
              // message: "Upload simulated (not sent)",
              // INSERTED: 0,
              // DELETED: 0
            // }
          // });
          
          // Old version (commented out):
          return uploadFaldonXlsx(file, loggedUser.username, faldon_version_json_dict[name], categoryMenu); // POST de subida de faldon
        })
      )
        .then((response) => {
          // Get category_menu from localStorage for error handling
          const savedSelectedMenu = localStorage.getItem(SMU_SELECTED_MENU);
          let categoryMenu = null;
          if (savedSelectedMenu) {
            try {
              const parsedMenu = JSON.parse(savedSelectedMenu);
              categoryMenu = parsedMenu?.id || null;
            } catch (err) {
              console.error("Error parsing SMU_SELECTED_MENU:", err);
            }
          }
          
          const _summary = multiFiles.map((file, index) => {
            const _s = {
              fileName: file.name,
              status: "success",
              message: "Carga completa.",
              icon: successIcon,
            };
            const res = response[index];
            if (res?.status === "rejected") {
              _s.status = "error";
              _s.icon = errorIcon;
              // Handle error cases based on backend response
              if (typeof res?.reason?.request === "object" && res?.reason?.request?.status !== undefined) {
                switch (res.reason.request.status) {
                  case 404:
                    _s.message = "No logró asociar una promoción al archivo.";
                    break;
                  case 400:
                    _s.message = "El contenido del faldón no corresponde al formato establecido.";
                    break;
                  case 0:
                    _s.message = "Error de red, intente nuevamente.";
                    break;
                  case 500:
                  default:
                    _s.message = "Error en la lectura del archivo.";
                    break;
                }
              // Error cases from fronend validation
              } else {
                switch (res?.reason) {
                  case "MENU-NOT-FOUND":
                    // Bypass this error if categoryMenu is valid (not null/empty)
                    if (categoryMenu && categoryMenu !== "") {
                      // Treat as success when categoryMenu is valid
                      _s.status = "success";
                      _s.icon = successIcon;
                      _s.message = "Carga completa.";
                    } else {
                      _s.message = "No logró asociar un menu al archivo.";
                    }
                    break;
                  case "NO-BRAND":
                    _s.message =
                      "EL portar indicado en el archivo no corresponde.";
                    break;
                  case "INVALID-SKIRT":
                    _s.message = "El faldón no corresponde al formato establecido.";
                    break;
                  default:
                    _s.message = "Error en la lectura del archivo.";
                    break;
                }
              }
            } else{
              if (res?.value?.data?.INSERTED && res?.value?.data?.DELETED !== undefined) {
                const action = res.value.data.DELETED > 0 ? "actualizado" : "añadido";
                _s.message = `Carga exitosa. Se han ${action} ${res.value.data.INSERTED} artículos correctamente.`;
              }
            }
            return _s;
          });
          setSummaryUpload(_summary);
          setSummaryModal(true);

          setLoading(false);
          resolve(_summary);
          setMultiFile([]);
          
          // Clear selected menu after successful upload
          setSelectedSkirt(null);
          setBreadcrumbs([]);
          localStorage.removeItem(SMU_SELECTED_MENU);
        })
        .catch((err) => {
          setLoading(false);
          reject(err);
          setMultiFile([]);
        });
    });
  };

  const handleDelete = (fileId) => {
    Swal.fire({
      title: "¿Deseas eliminar este faldón?",
      showCancelButton: true,
      confirmButtonText: "Eliminar",
      confirmButtonColor: COLOR_PRIMARY,
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (!result.isConfirmed) return;
      setLoading(true);
      deleteFaldonXlsx(fileId, loggedUser?.username)
        .then(({ data }) => {
          toast({ icon: "success", title: "Faldón eliminado correctamente." });
          hnadleFetchFiles(selectedSkirt.id);
        })
        .catch((err) => {
          toast({ icon: "error", title: "Error al eliminar el faldón." });
        })
        .finally(() => {
          setLoading(false);
        });
    });
  };

  // const handleUploadXlsx = async () => {
  //   if (!loggedUser?.username) {
  //     toast({ icon: "error", title: "No se encontró el sesión usuaria." });
  //     return {error: true, type: 'faldon'};
  //   }
  //   //filename verifications
  //   //... BRAND - MENU - MENU2 - PROMOTION .xlsx || BRAND - MENU - PROMOTION .xlsx
  //   try {
  //     const result = await uploadFaldonXlsx(file, loggedUser.username, selectedSkirt.id);
  //     let msg = "Archivo XLSX cargado correctamente.";
  //     if (result?.data?.INSERTED && result?.data?.DELETED !== undefined) {
  //       const action = result.data.DELETED > 0 ? "actualizado" : "añadido";
  //       msg = `Carga exitosa. Se han ${action} ${result.data.INSERTED} artículos correctamente.`;
  //     }
  //     toast({ icon: "success", title: msg });
  //     setXlsxToUpload([]);
  //     hnadleFetchFiles(selectedSkirt.id);
  //     return {error: false, type: 'faldon'};
  //   } catch (err) {
  //     let msg = "Error al cargar el faldón XLSX.";
  //     switch (err.request?.status) {
  //       case 404:
  //         msg = "No logró asociar una promoción al archivo.";
  //         break;
  //       case 400:
  //         msg = "El contenido del faldón no corresponde al formato establecido.";
  //         break;
  //       case 0:
  //         msg = "Error de red, intente nuevamente.";
  //         break;
  //       case 500:
  //       default:
  //         msg = "Error en la lectura del archivo Excel.";
  //         break;
  //     }
  //     toast({ icon: "error", title: msg });
  //     return {error: true, type: 'faldon'};
  //   }
  // };

  const handlePreviewSelectedFiles = async () => {
    if (!multiFiles?.length) {
      toast({ icon: "error", title: "Selecciona uno o más archivos XLSX." });
      return;
    }
    setLoading(true);
    try {
      const parsed = await Promise.all(multiFiles.map((f) => parseFaldonXlsx(f)));
      setParsedFilesPreview(parsed);
      setPreviewOpen(true);
    } catch (e) {
      toast({ icon: "error", title: "No fue posible leer los Excel seleccionados." });
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      name: "Nombre de archivo",
      selector: (row) => row.filename,
      sortable: true,
      cell: (row) => <div className="cell text-truncate" title={row.filename} >{row.filename}</div>,
      width: "60%",
    },
    {
      name: "Visualizaciones",
      selector: (row) => row.views,
      sortable: true,
      cell: (row) => <div className="cell text-center">{row.views}</div>,
      width: "30%",
    },
    {
      name: "",
      width: "10%",
      selector: (row) => row.id,
      cell: (row) => (
        <div className="cell w-100 d-flex">
          <SmuButton
            _className="ms-auto"
            control={() => handleDelete(row.id)}
          >
            <IconBasket color="#33383F" />
          </SmuButton>
        </div>
      ),
    },
  ];

  return (
    <>
      <Modal
        show={summaryModal}
        onHide={() => setSummaryModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Resumen de carga
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {summaryUpload.map((summary, index) => (
            <div key={index} className="d-flex align-items-center mb-2">
              <img src={summary.icon} alt="RESPONSE" height={25} width={25} />
              <div className="ms-2" style={{ whiteSpace: "nowrap" }}>
                {summary.fileName}:
              </div>
              <p
                className={`ms-3 mb-0 ${
                  summary.status === "error" ? "text-danger" : "text-success"
                }`}
              >
                {summary.message}
              </p>
            </div>
          ))}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setSummaryModal(false)}>Cerrar</Button>
        </Modal.Footer>
      </Modal>

      <PreviewXlsxModal
        show={previewOpen}
        onHide={() => setPreviewOpen(false)}
        parsed={parsedFilesPreview}
        files={multiFiles}
        handleUploadProcess={handleUploadFileMultiple}
        calculateCategoryMenu={calculateCategoryMenu}
      />

      <Card className="smu-card">
        <Card.Header className="d-flex align-items-center py-4">
          <div className="d-flex align-items-center">
            <SmuBadge color="#FFD88D" />
            <span className="fs-5 ms-3 me-auto">Cargar Faldones</span>
          </div>
        </Card.Header>

        <Card.Body>
          <Row>
            <Col col={12} lg={6}>
              <div className="mt-4">
                <div className="h6 mb-2">Seleccionar Menú</div>
                {/* Breadcrumbs 
                {breadcrumbs.length > 0 && (
                  <div className="mb-3">
                    <span className="youre-in">Estás en: </span>
                    <span className="breadcrumbs">{breadcrumbs.join(" / ")}</span>
                  </div>
                )}*/}
                <div style={{ position: "relative", minHeight: "200px" }}>
                  {loadingSkirt && (
                    <div className="d-flex align-items-center justify-content-center" style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, zIndex: 10, backgroundColor: "rgba(255, 255, 255, 0.8)" }}>
                      <SmuLoading label="Cargando" />
                    </div>
                  )}
                  <Tree
                    tree={treeData}
                    rootId={0}
                    classes={{
                      root: "skirt-list",
                    }}
                    render={(node, props) => (
                      <SkirtItem
                        node={node}
                        {...props}
                        choseSkirt={handleChoseSkirt}
                        active={selectedSkirt?.id === node.id}
                        // Old version (commented out):
                        // choseSkirt={handleChoseSkirt}
                        // active={selectedSkirt?.id === node.id}
                      />
                    )}
                    sort={false}
                    insertDroppableFirst={false}
                  />
                </div>
              </div>
            </Col>
            <Col col={12} lg={6}>
              <div className="youre-in mb-1">Estas en:</div>
                <div className="breadcrumbs">
                  Faldones / {breadcrumbs.join(" / ")}
              </div>

              <div className="mt-4">
                <div className="h6 mb-2">Cargar archivo de Faldones (XLSX)</div>
                
                  <SmuFileUploader
                    uploadFile={handlePreviewSelectedFiles}
                    acceptedTypes={acceptedXlsxTypes}
                    files={multiFiles}
                    setFiles={setMultiFile}
                    multiple={true}
                    needPromo={false}
                    verifyPrefix={true}
                    autoClean={false}
                    blockButtons={loading}
                  />
                  {loading && (
                    <div className="d-flex align-items-center justify-content-center my-3">
                      <SmuLoading label="Procesando carga de faldones..." />
                    </div>
                  )}
              </div>
              {/* Faldones cargados
              {selectedSkirt && files.length > 0 && (
                <div className="mt-4">
                  <div className="h6 mb-2">Faldones cargados</div>
                  <SmuTable columns={columns} data={files} loading={loading} />
                </div>
              )}*/}
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};

export default LoadSkirts;